import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { fmtNum, fmtPct } from "@/lib/verizonSalesApi";

export const GroupBreakdown = ({ title, icon: Icon, groups, testId }) => (
  <Card className="border-slate-200" data-testid={testId}>
    <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><Icon className="w-4 h-4 text-teal" /> {title}</CardTitle></CardHeader>
    <CardContent className="space-y-2.5 max-h-80 overflow-y-auto">
      {groups.map((g) => {
        const pct = g.pacing_pct || 0;
        return (
          <div key={g.name} data-testid={`${testId}-${g.name}`}>
            <div className="flex justify-between text-xs">
              <span className="font-medium text-navy truncate pr-2">{g.name} <span className="text-slate-400">({g.stores})</span></span>
              <span className="tabular-nums text-slate-600 whitespace-nowrap">{fmtNum(g.current_acts)} acts · <b className={pct >= 1 ? "text-emerald-600" : pct >= 0.85 ? "text-amber-600" : "text-red-600"}>{fmtPct(g.pacing_pct)}</b></span>
            </div>
            <div className="h-1.5 bg-slate-100 rounded-full mt-1 overflow-hidden">
              <div className={`h-full rounded-full ${pct >= 1 ? "bg-emerald-500" : pct >= 0.85 ? "bg-amber-500" : "bg-red-500"}`} style={{ width: `${Math.min(pct, 1.5) / 1.5 * 100}%` }} />
            </div>
          </div>
        );
      })}
    </CardContent>
  </Card>
);
